module.exports = __webpack_public_path__ + "img/carnival-left.da0dc1e7.png";